/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspacesRouteImport } from './routes/workspaces'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrometeusRouteImport } from './routes/prometeus'
import { Route as PoliticaPrivacidadeCookiesRouteImport } from './routes/politica-privacidade-cookies'
import { Route as PoliticaCancelamentoReembolsoRouteImport } from './routes/politica-cancelamento-reembolso'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvitesRouteImport } from './routes/invites'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as ClientRouteImport } from './routes/client'
import { Route as CertificacaoRouteImport } from './routes/certificacao'
import { Route as AssinaturasRouteImport } from './routes/assinaturas'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CommunityIndexRouteImport } from './routes/community.index'
import { Route as ClientIndexRouteImport } from './routes/client.index'
import { Route as CertificacaoIndexRouteImport } from './routes/certificacao.index'
import { Route as RegisterInviteTokenRouteImport } from './routes/register-invite.$token'
import { Route as RegisterClientInviteTokenRouteImport } from './routes/register-client-invite.$token'
import { Route as CommunitySearchRouteImport } from './routes/community.search'
import { Route as CommunityJobsRouteImport } from './routes/community.jobs'
import { Route as CommunityFeedRouteImport } from './routes/community.feed'
import { Route as CommunityConnectionsRouteImport } from './routes/community.connections'
import { Route as ClientInvitesRouteImport } from './routes/client.invites'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as CheckoutCancelRouteImport } from './routes/checkout.cancel'
import { Route as CommunityJobsIndexRouteImport } from './routes/community.jobs.index'
import { Route as WWorkspaceIdWorkflowPresetsRouteImport } from './routes/w.$workspaceId.workflow-presets'
import { Route as WWorkspaceIdTasksRouteImport } from './routes/w.$workspaceId.tasks'
import { Route as WWorkspaceIdShopRouteImport } from './routes/w.$workspaceId.shop'
import { Route as WWorkspaceIdPublicationsRouteImport } from './routes/w.$workspaceId.publications'
import { Route as WWorkspaceIdPlanRouteImport } from './routes/w.$workspaceId.plan'
import { Route as WWorkspaceIdNotificationsRouteImport } from './routes/w.$workspaceId.notifications'
import { Route as WWorkspaceIdMetricsRouteImport } from './routes/w.$workspaceId.metrics'
import { Route as WWorkspaceIdGamificationRouteImport } from './routes/w.$workspaceId.gamification'
import { Route as WWorkspaceIdFinanceiroRouteImport } from './routes/w.$workspaceId.financeiro'
import { Route as WWorkspaceIdDocumentsRouteImport } from './routes/w.$workspaceId.documents'
import { Route as WWorkspaceIdClientsRouteImport } from './routes/w.$workspaceId.clients'
import { Route as WWorkspaceIdClientInvitesRouteImport } from './routes/w.$workspaceId.client-invites'
import { Route as WWorkspaceIdChatRouteImport } from './routes/w.$workspaceId.chat'
import { Route as WWorkspaceIdCertificacoesRouteImport } from './routes/w.$workspaceId.certificacoes'
import { Route as WWorkspaceIdAgendaRouteImport } from './routes/w.$workspaceId.agenda'
import { Route as CommunityProfileEditRouteImport } from './routes/community.profile.edit'
import { Route as CommunityProfileUserIdRouteImport } from './routes/community.profile.$userId'
import { Route as CommunityJobsNewRouteImport } from './routes/community.jobs.new'
import { Route as CommunityJobsJobIdRouteImport } from './routes/community.jobs.$jobId'
import { Route as CommunityArticlesNewRouteImport } from './routes/community.articles.new'
import { Route as CommunityArticlesArticleIdRouteImport } from './routes/community.articles.$articleId'
import { Route as ClientProcessesProcessIdRouteImport } from './routes/client.processes.$processId'
import { Route as CertificacaoCursosCourseIdRouteImport } from './routes/certificacao.cursos.$courseId'
import { Route as CertificacaoCertificadosIdRouteImport } from './routes/certificacao.certificados.$id'
import { Route as AdminWorkspaceWorkspaceIdRouteImport } from './routes/admin.workspace.$workspaceId'
import { Route as WWorkspaceIdWorkflowPresetsIndexRouteImport } from './routes/w.$workspaceId.workflow-presets.index'
import { Route as WWorkspaceIdFinanceiroIndexRouteImport } from './routes/w.$workspaceId.financeiro.index'
import { Route as ClientProcessesProcessIdIndexRouteImport } from './routes/client.processes.$processId.index'
import { Route as CertificacaoCursosCourseIdIndexRouteImport } from './routes/certificacao.cursos.$courseId.index'
import { Route as WWorkspaceIdWorkflowPresetsPresetIdRouteImport } from './routes/w.$workspaceId.workflow-presets.$presetId'
import { Route as WWorkspaceIdSettingsWorkflowPresetsRouteImport } from './routes/w.$workspaceId.settings.workflow-presets'
import { Route as WWorkspaceIdSettingsWorkGroupsRouteImport } from './routes/w.$workspaceId.settings.work-groups'
import { Route as WWorkspaceIdSettingsTermosRouteImport } from './routes/w.$workspaceId.settings.termos'
import { Route as WWorkspaceIdSettingsTagsRouteImport } from './routes/w.$workspaceId.settings.tags'
import { Route as WWorkspaceIdSettingsRolesRouteImport } from './routes/w.$workspaceId.settings.roles'
import { Route as WWorkspaceIdSettingsMembersRouteImport } from './routes/w.$workspaceId.settings.members'
import { Route as WWorkspaceIdSettingsGamificationRouteImport } from './routes/w.$workspaceId.settings.gamification'
import { Route as WWorkspaceIdSettingsCertificationsRouteImport } from './routes/w.$workspaceId.settings.certifications'
import { Route as WWorkspaceIdProcessesExternalSearchDetailsRouteImport } from './routes/w.$workspaceId.processes.external-search-details'
import { Route as WWorkspaceIdProcessesExternalSearchRouteImport } from './routes/w.$workspaceId.processes.external-search'
import { Route as WWorkspaceIdFinanceiroResumoRouteImport } from './routes/w.$workspaceId.financeiro.resumo'
import { Route as WWorkspaceIdFinanceiroPrevisaoSucumbenciaRouteImport } from './routes/w.$workspaceId.financeiro.previsao-sucumbencia'
import { Route as WWorkspaceIdFinanceiroPendenciasRouteImport } from './routes/w.$workspaceId.financeiro.pendencias'
import { Route as WWorkspaceIdFinanceiroLancamentosRouteImport } from './routes/w.$workspaceId.financeiro.lancamentos'
import { Route as WWorkspaceIdFinanceiroImportacaoRouteImport } from './routes/w.$workspaceId.financeiro.importacao'
import { Route as WWorkspaceIdFinanceiroFluxoRouteImport } from './routes/w.$workspaceId.financeiro.fluxo'
import { Route as WWorkspaceIdFinanceiroContasReceberRouteImport } from './routes/w.$workspaceId.financeiro.contas-receber'
import { Route as WWorkspaceIdFinanceiroContasPagarRouteImport } from './routes/w.$workspaceId.financeiro.contas-pagar'
import { Route as WWorkspaceIdFinanceiroConfiguracoesRouteImport } from './routes/w.$workspaceId.financeiro.configuracoes'
import { Route as WWorkspaceIdClientsNewRouteImport } from './routes/w.$workspaceId.clients.new'
import { Route as WWorkspaceIdClientsClientIdRouteImport } from './routes/w.$workspaceId.clients.$clientId'
import { Route as ClientProcessesProcessIdTasksRouteImport } from './routes/client.processes.$processId.tasks'
import { Route as ClientProcessesProcessIdSyncHistoryRouteImport } from './routes/client.processes.$processId.sync-history'
import { Route as CertificacaoCursosCourseIdSimuladoRouteImport } from './routes/certificacao.cursos.$courseId.simulado'
import { Route as AdminTribunaisTribunalIdCalibracaoRouteImport } from './routes/admin.tribunais.$tribunalId.calibracao'
import { Route as WWorkspaceIdClientsClientIdProcessesRouteImport } from './routes/w.$workspaceId.clients.$clientId.processes'
import { Route as WWorkspaceIdClientsClientIdDocumentsRouteImport } from './routes/w.$workspaceId.clients.$clientId.documents'
import { Route as CertificacaoCursosCourseIdEtapaStepIdRouteImport } from './routes/certificacao.cursos.$courseId.etapa.$stepId'
import { Route as WWorkspaceIdClientsClientIdProcessesProcessIdRouteImport } from './routes/w.$workspaceId.clients.$clientId.processes.$processId'
import { Route as WWorkspaceIdClientsClientIdProcessesProcessIdIndexRouteImport } from './routes/w.$workspaceId.clients.$clientId.processes.$processId.index'
import { Route as WWorkspaceIdClientsClientIdProcessesProcessIdTasksRouteImport } from './routes/w.$workspaceId.clients.$clientId.processes.$processId.tasks'
import { Route as WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRouteImport } from './routes/w.$workspaceId.clients.$clientId.processes.$processId.sync-history'
import { Route as WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRouteImport } from './routes/w.$workspaceId.clients.$clientId.processes.$processId.financeiro'

const WorkspacesRoute = WorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PrometeusRoute = PrometeusRouteImport.update({
  id: '/prometeus',
  path: '/prometeus',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaPrivacidadeCookiesRoute =
  PoliticaPrivacidadeCookiesRouteImport.update({
    id: '/politica-privacidade-cookies',
    path: '/politica-privacidade-cookies',
    getParentRoute: () => rootRouteImport,
  } as any)
const PoliticaCancelamentoReembolsoRoute =
  PoliticaCancelamentoReembolsoRouteImport.update({
    id: '/politica-cancelamento-reembolso',
    path: '/politica-cancelamento-reembolso',
    getParentRoute: () => rootRouteImport,
  } as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesRoute = InvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityRoute = CommunityRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRoute = ClientRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificacaoRoute = CertificacaoRouteImport.update({
  id: '/certificacao',
  path: '/certificacao',
  getParentRoute: () => rootRouteImport,
} as any)
const AssinaturasRoute = AssinaturasRouteImport.update({
  id: '/assinaturas',
  path: '/assinaturas',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityIndexRoute = CommunityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommunityRoute,
} as any)
const ClientIndexRoute = ClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientRoute,
} as any)
const CertificacaoIndexRoute = CertificacaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CertificacaoRoute,
} as any)
const RegisterInviteTokenRoute = RegisterInviteTokenRouteImport.update({
  id: '/register-invite/$token',
  path: '/register-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterClientInviteTokenRoute =
  RegisterClientInviteTokenRouteImport.update({
    id: '/register-client-invite/$token',
    path: '/register-client-invite/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const CommunitySearchRoute = CommunitySearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => CommunityRoute,
} as any)
const CommunityJobsRoute = CommunityJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => CommunityRoute,
} as any)
const CommunityFeedRoute = CommunityFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => CommunityRoute,
} as any)
const CommunityConnectionsRoute = CommunityConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => CommunityRoute,
} as any)
const ClientInvitesRoute = ClientInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => ClientRoute,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
  id: '/checkout/cancel',
  path: '/checkout/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityJobsIndexRoute = CommunityJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommunityJobsRoute,
} as any)
const WWorkspaceIdWorkflowPresetsRoute =
  WWorkspaceIdWorkflowPresetsRouteImport.update({
    id: '/w/$workspaceId/workflow-presets',
    path: '/w/$workspaceId/workflow-presets',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdTasksRoute = WWorkspaceIdTasksRouteImport.update({
  id: '/w/$workspaceId/tasks',
  path: '/w/$workspaceId/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdShopRoute = WWorkspaceIdShopRouteImport.update({
  id: '/w/$workspaceId/shop',
  path: '/w/$workspaceId/shop',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdPublicationsRoute =
  WWorkspaceIdPublicationsRouteImport.update({
    id: '/w/$workspaceId/publications',
    path: '/w/$workspaceId/publications',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdPlanRoute = WWorkspaceIdPlanRouteImport.update({
  id: '/w/$workspaceId/plan',
  path: '/w/$workspaceId/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdNotificationsRoute =
  WWorkspaceIdNotificationsRouteImport.update({
    id: '/w/$workspaceId/notifications',
    path: '/w/$workspaceId/notifications',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdMetricsRoute = WWorkspaceIdMetricsRouteImport.update({
  id: '/w/$workspaceId/metrics',
  path: '/w/$workspaceId/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdGamificationRoute =
  WWorkspaceIdGamificationRouteImport.update({
    id: '/w/$workspaceId/gamification',
    path: '/w/$workspaceId/gamification',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdFinanceiroRoute = WWorkspaceIdFinanceiroRouteImport.update({
  id: '/w/$workspaceId/financeiro',
  path: '/w/$workspaceId/financeiro',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdDocumentsRoute = WWorkspaceIdDocumentsRouteImport.update({
  id: '/w/$workspaceId/documents',
  path: '/w/$workspaceId/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdClientsRoute = WWorkspaceIdClientsRouteImport.update({
  id: '/w/$workspaceId/clients',
  path: '/w/$workspaceId/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdClientInvitesRoute =
  WWorkspaceIdClientInvitesRouteImport.update({
    id: '/w/$workspaceId/client-invites',
    path: '/w/$workspaceId/client-invites',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdChatRoute = WWorkspaceIdChatRouteImport.update({
  id: '/w/$workspaceId/chat',
  path: '/w/$workspaceId/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdCertificacoesRoute =
  WWorkspaceIdCertificacoesRouteImport.update({
    id: '/w/$workspaceId/certificacoes',
    path: '/w/$workspaceId/certificacoes',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdAgendaRoute = WWorkspaceIdAgendaRouteImport.update({
  id: '/w/$workspaceId/agenda',
  path: '/w/$workspaceId/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityProfileEditRoute = CommunityProfileEditRouteImport.update({
  id: '/profile/edit',
  path: '/profile/edit',
  getParentRoute: () => CommunityRoute,
} as any)
const CommunityProfileUserIdRoute = CommunityProfileUserIdRouteImport.update({
  id: '/profile/$userId',
  path: '/profile/$userId',
  getParentRoute: () => CommunityRoute,
} as any)
const CommunityJobsNewRoute = CommunityJobsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CommunityJobsRoute,
} as any)
const CommunityJobsJobIdRoute = CommunityJobsJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => CommunityJobsRoute,
} as any)
const CommunityArticlesNewRoute = CommunityArticlesNewRouteImport.update({
  id: '/articles/new',
  path: '/articles/new',
  getParentRoute: () => CommunityRoute,
} as any)
const CommunityArticlesArticleIdRoute =
  CommunityArticlesArticleIdRouteImport.update({
    id: '/articles/$articleId',
    path: '/articles/$articleId',
    getParentRoute: () => CommunityRoute,
  } as any)
const ClientProcessesProcessIdRoute =
  ClientProcessesProcessIdRouteImport.update({
    id: '/processes/$processId',
    path: '/processes/$processId',
    getParentRoute: () => ClientRoute,
  } as any)
const CertificacaoCursosCourseIdRoute =
  CertificacaoCursosCourseIdRouteImport.update({
    id: '/cursos/$courseId',
    path: '/cursos/$courseId',
    getParentRoute: () => CertificacaoRoute,
  } as any)
const CertificacaoCertificadosIdRoute =
  CertificacaoCertificadosIdRouteImport.update({
    id: '/certificados/$id',
    path: '/certificados/$id',
    getParentRoute: () => CertificacaoRoute,
  } as any)
const AdminWorkspaceWorkspaceIdRoute =
  AdminWorkspaceWorkspaceIdRouteImport.update({
    id: '/workspace/$workspaceId',
    path: '/workspace/$workspaceId',
    getParentRoute: () => AdminRoute,
  } as any)
const WWorkspaceIdWorkflowPresetsIndexRoute =
  WWorkspaceIdWorkflowPresetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceIdWorkflowPresetsRoute,
  } as any)
const WWorkspaceIdFinanceiroIndexRoute =
  WWorkspaceIdFinanceiroIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const ClientProcessesProcessIdIndexRoute =
  ClientProcessesProcessIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClientProcessesProcessIdRoute,
  } as any)
const CertificacaoCursosCourseIdIndexRoute =
  CertificacaoCursosCourseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CertificacaoCursosCourseIdRoute,
  } as any)
const WWorkspaceIdWorkflowPresetsPresetIdRoute =
  WWorkspaceIdWorkflowPresetsPresetIdRouteImport.update({
    id: '/$presetId',
    path: '/$presetId',
    getParentRoute: () => WWorkspaceIdWorkflowPresetsRoute,
  } as any)
const WWorkspaceIdSettingsWorkflowPresetsRoute =
  WWorkspaceIdSettingsWorkflowPresetsRouteImport.update({
    id: '/w/$workspaceId/settings/workflow-presets',
    path: '/w/$workspaceId/settings/workflow-presets',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsWorkGroupsRoute =
  WWorkspaceIdSettingsWorkGroupsRouteImport.update({
    id: '/w/$workspaceId/settings/work-groups',
    path: '/w/$workspaceId/settings/work-groups',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsTermosRoute =
  WWorkspaceIdSettingsTermosRouteImport.update({
    id: '/w/$workspaceId/settings/termos',
    path: '/w/$workspaceId/settings/termos',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsTagsRoute =
  WWorkspaceIdSettingsTagsRouteImport.update({
    id: '/w/$workspaceId/settings/tags',
    path: '/w/$workspaceId/settings/tags',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsRolesRoute =
  WWorkspaceIdSettingsRolesRouteImport.update({
    id: '/w/$workspaceId/settings/roles',
    path: '/w/$workspaceId/settings/roles',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsMembersRoute =
  WWorkspaceIdSettingsMembersRouteImport.update({
    id: '/w/$workspaceId/settings/members',
    path: '/w/$workspaceId/settings/members',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsGamificationRoute =
  WWorkspaceIdSettingsGamificationRouteImport.update({
    id: '/w/$workspaceId/settings/gamification',
    path: '/w/$workspaceId/settings/gamification',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdSettingsCertificationsRoute =
  WWorkspaceIdSettingsCertificationsRouteImport.update({
    id: '/w/$workspaceId/settings/certifications',
    path: '/w/$workspaceId/settings/certifications',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdProcessesExternalSearchDetailsRoute =
  WWorkspaceIdProcessesExternalSearchDetailsRouteImport.update({
    id: '/w/$workspaceId/processes/external-search-details',
    path: '/w/$workspaceId/processes/external-search-details',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdProcessesExternalSearchRoute =
  WWorkspaceIdProcessesExternalSearchRouteImport.update({
    id: '/w/$workspaceId/processes/external-search',
    path: '/w/$workspaceId/processes/external-search',
    getParentRoute: () => rootRouteImport,
  } as any)
const WWorkspaceIdFinanceiroResumoRoute =
  WWorkspaceIdFinanceiroResumoRouteImport.update({
    id: '/resumo',
    path: '/resumo',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute =
  WWorkspaceIdFinanceiroPrevisaoSucumbenciaRouteImport.update({
    id: '/previsao-sucumbencia',
    path: '/previsao-sucumbencia',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroPendenciasRoute =
  WWorkspaceIdFinanceiroPendenciasRouteImport.update({
    id: '/pendencias',
    path: '/pendencias',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroLancamentosRoute =
  WWorkspaceIdFinanceiroLancamentosRouteImport.update({
    id: '/lancamentos',
    path: '/lancamentos',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroImportacaoRoute =
  WWorkspaceIdFinanceiroImportacaoRouteImport.update({
    id: '/importacao',
    path: '/importacao',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroFluxoRoute =
  WWorkspaceIdFinanceiroFluxoRouteImport.update({
    id: '/fluxo',
    path: '/fluxo',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroContasReceberRoute =
  WWorkspaceIdFinanceiroContasReceberRouteImport.update({
    id: '/contas-receber',
    path: '/contas-receber',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroContasPagarRoute =
  WWorkspaceIdFinanceiroContasPagarRouteImport.update({
    id: '/contas-pagar',
    path: '/contas-pagar',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdFinanceiroConfiguracoesRoute =
  WWorkspaceIdFinanceiroConfiguracoesRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => WWorkspaceIdFinanceiroRoute,
  } as any)
const WWorkspaceIdClientsNewRoute = WWorkspaceIdClientsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WWorkspaceIdClientsRoute,
} as any)
const WWorkspaceIdClientsClientIdRoute =
  WWorkspaceIdClientsClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => WWorkspaceIdClientsRoute,
  } as any)
const ClientProcessesProcessIdTasksRoute =
  ClientProcessesProcessIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => ClientProcessesProcessIdRoute,
  } as any)
const ClientProcessesProcessIdSyncHistoryRoute =
  ClientProcessesProcessIdSyncHistoryRouteImport.update({
    id: '/sync-history',
    path: '/sync-history',
    getParentRoute: () => ClientProcessesProcessIdRoute,
  } as any)
const CertificacaoCursosCourseIdSimuladoRoute =
  CertificacaoCursosCourseIdSimuladoRouteImport.update({
    id: '/simulado',
    path: '/simulado',
    getParentRoute: () => CertificacaoCursosCourseIdRoute,
  } as any)
const AdminTribunaisTribunalIdCalibracaoRoute =
  AdminTribunaisTribunalIdCalibracaoRouteImport.update({
    id: '/tribunais/$tribunalId/calibracao',
    path: '/tribunais/$tribunalId/calibracao',
    getParentRoute: () => AdminRoute,
  } as any)
const WWorkspaceIdClientsClientIdProcessesRoute =
  WWorkspaceIdClientsClientIdProcessesRouteImport.update({
    id: '/processes',
    path: '/processes',
    getParentRoute: () => WWorkspaceIdClientsClientIdRoute,
  } as any)
const WWorkspaceIdClientsClientIdDocumentsRoute =
  WWorkspaceIdClientsClientIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => WWorkspaceIdClientsClientIdRoute,
  } as any)
const CertificacaoCursosCourseIdEtapaStepIdRoute =
  CertificacaoCursosCourseIdEtapaStepIdRouteImport.update({
    id: '/etapa/$stepId',
    path: '/etapa/$stepId',
    getParentRoute: () => CertificacaoCursosCourseIdRoute,
  } as any)
const WWorkspaceIdClientsClientIdProcessesProcessIdRoute =
  WWorkspaceIdClientsClientIdProcessesProcessIdRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => WWorkspaceIdClientsClientIdProcessesRoute,
  } as any)
const WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute =
  WWorkspaceIdClientsClientIdProcessesProcessIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WWorkspaceIdClientsClientIdProcessesProcessIdRoute,
  } as any)
const WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute =
  WWorkspaceIdClientsClientIdProcessesProcessIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => WWorkspaceIdClientsClientIdProcessesProcessIdRoute,
  } as any)
const WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute =
  WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRouteImport.update({
    id: '/sync-history',
    path: '/sync-history',
    getParentRoute: () => WWorkspaceIdClientsClientIdProcessesProcessIdRoute,
  } as any)
const WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute =
  WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRouteImport.update({
    id: '/financeiro',
    path: '/financeiro',
    getParentRoute: () => WWorkspaceIdClientsClientIdProcessesProcessIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/assinaturas': typeof AssinaturasRoute
  '/certificacao': typeof CertificacaoRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/community': typeof CommunityRouteWithChildren
  '/invites': typeof InvitesRoute
  '/login': typeof LoginRoute
  '/politica-cancelamento-reembolso': typeof PoliticaCancelamentoReembolsoRoute
  '/politica-privacidade-cookies': typeof PoliticaPrivacidadeCookiesRoute
  '/prometeus': typeof PrometeusRoute
  '/settings': typeof SettingsRoute
  '/termos': typeof TermosRoute
  '/workspaces': typeof WorkspacesRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/client/invites': typeof ClientInvitesRoute
  '/community/connections': typeof CommunityConnectionsRoute
  '/community/feed': typeof CommunityFeedRoute
  '/community/jobs': typeof CommunityJobsRouteWithChildren
  '/community/search': typeof CommunitySearchRoute
  '/register-client-invite/$token': typeof RegisterClientInviteTokenRoute
  '/register-invite/$token': typeof RegisterInviteTokenRoute
  '/certificacao/': typeof CertificacaoIndexRoute
  '/client/': typeof ClientIndexRoute
  '/community/': typeof CommunityIndexRoute
  '/admin/workspace/$workspaceId': typeof AdminWorkspaceWorkspaceIdRoute
  '/certificacao/certificados/$id': typeof CertificacaoCertificadosIdRoute
  '/certificacao/cursos/$courseId': typeof CertificacaoCursosCourseIdRouteWithChildren
  '/client/processes/$processId': typeof ClientProcessesProcessIdRouteWithChildren
  '/community/articles/$articleId': typeof CommunityArticlesArticleIdRoute
  '/community/articles/new': typeof CommunityArticlesNewRoute
  '/community/jobs/$jobId': typeof CommunityJobsJobIdRoute
  '/community/jobs/new': typeof CommunityJobsNewRoute
  '/community/profile/$userId': typeof CommunityProfileUserIdRoute
  '/community/profile/edit': typeof CommunityProfileEditRoute
  '/w/$workspaceId/agenda': typeof WWorkspaceIdAgendaRoute
  '/w/$workspaceId/certificacoes': typeof WWorkspaceIdCertificacoesRoute
  '/w/$workspaceId/chat': typeof WWorkspaceIdChatRoute
  '/w/$workspaceId/client-invites': typeof WWorkspaceIdClientInvitesRoute
  '/w/$workspaceId/clients': typeof WWorkspaceIdClientsRouteWithChildren
  '/w/$workspaceId/documents': typeof WWorkspaceIdDocumentsRoute
  '/w/$workspaceId/financeiro': typeof WWorkspaceIdFinanceiroRouteWithChildren
  '/w/$workspaceId/gamification': typeof WWorkspaceIdGamificationRoute
  '/w/$workspaceId/metrics': typeof WWorkspaceIdMetricsRoute
  '/w/$workspaceId/notifications': typeof WWorkspaceIdNotificationsRoute
  '/w/$workspaceId/plan': typeof WWorkspaceIdPlanRoute
  '/w/$workspaceId/publications': typeof WWorkspaceIdPublicationsRoute
  '/w/$workspaceId/shop': typeof WWorkspaceIdShopRoute
  '/w/$workspaceId/tasks': typeof WWorkspaceIdTasksRoute
  '/w/$workspaceId/workflow-presets': typeof WWorkspaceIdWorkflowPresetsRouteWithChildren
  '/community/jobs/': typeof CommunityJobsIndexRoute
  '/admin/tribunais/$tribunalId/calibracao': typeof AdminTribunaisTribunalIdCalibracaoRoute
  '/certificacao/cursos/$courseId/simulado': typeof CertificacaoCursosCourseIdSimuladoRoute
  '/client/processes/$processId/sync-history': typeof ClientProcessesProcessIdSyncHistoryRoute
  '/client/processes/$processId/tasks': typeof ClientProcessesProcessIdTasksRoute
  '/w/$workspaceId/clients/$clientId': typeof WWorkspaceIdClientsClientIdRouteWithChildren
  '/w/$workspaceId/clients/new': typeof WWorkspaceIdClientsNewRoute
  '/w/$workspaceId/financeiro/configuracoes': typeof WWorkspaceIdFinanceiroConfiguracoesRoute
  '/w/$workspaceId/financeiro/contas-pagar': typeof WWorkspaceIdFinanceiroContasPagarRoute
  '/w/$workspaceId/financeiro/contas-receber': typeof WWorkspaceIdFinanceiroContasReceberRoute
  '/w/$workspaceId/financeiro/fluxo': typeof WWorkspaceIdFinanceiroFluxoRoute
  '/w/$workspaceId/financeiro/importacao': typeof WWorkspaceIdFinanceiroImportacaoRoute
  '/w/$workspaceId/financeiro/lancamentos': typeof WWorkspaceIdFinanceiroLancamentosRoute
  '/w/$workspaceId/financeiro/pendencias': typeof WWorkspaceIdFinanceiroPendenciasRoute
  '/w/$workspaceId/financeiro/previsao-sucumbencia': typeof WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute
  '/w/$workspaceId/financeiro/resumo': typeof WWorkspaceIdFinanceiroResumoRoute
  '/w/$workspaceId/processes/external-search': typeof WWorkspaceIdProcessesExternalSearchRoute
  '/w/$workspaceId/processes/external-search-details': typeof WWorkspaceIdProcessesExternalSearchDetailsRoute
  '/w/$workspaceId/settings/certifications': typeof WWorkspaceIdSettingsCertificationsRoute
  '/w/$workspaceId/settings/gamification': typeof WWorkspaceIdSettingsGamificationRoute
  '/w/$workspaceId/settings/members': typeof WWorkspaceIdSettingsMembersRoute
  '/w/$workspaceId/settings/roles': typeof WWorkspaceIdSettingsRolesRoute
  '/w/$workspaceId/settings/tags': typeof WWorkspaceIdSettingsTagsRoute
  '/w/$workspaceId/settings/termos': typeof WWorkspaceIdSettingsTermosRoute
  '/w/$workspaceId/settings/work-groups': typeof WWorkspaceIdSettingsWorkGroupsRoute
  '/w/$workspaceId/settings/workflow-presets': typeof WWorkspaceIdSettingsWorkflowPresetsRoute
  '/w/$workspaceId/workflow-presets/$presetId': typeof WWorkspaceIdWorkflowPresetsPresetIdRoute
  '/certificacao/cursos/$courseId/': typeof CertificacaoCursosCourseIdIndexRoute
  '/client/processes/$processId/': typeof ClientProcessesProcessIdIndexRoute
  '/w/$workspaceId/financeiro/': typeof WWorkspaceIdFinanceiroIndexRoute
  '/w/$workspaceId/workflow-presets/': typeof WWorkspaceIdWorkflowPresetsIndexRoute
  '/certificacao/cursos/$courseId/etapa/$stepId': typeof CertificacaoCursosCourseIdEtapaStepIdRoute
  '/w/$workspaceId/clients/$clientId/documents': typeof WWorkspaceIdClientsClientIdDocumentsRoute
  '/w/$workspaceId/clients/$clientId/processes': typeof WWorkspaceIdClientsClientIdProcessesRouteWithChildren
  '/w/$workspaceId/clients/$clientId/processes/$processId': typeof WWorkspaceIdClientsClientIdProcessesProcessIdRouteWithChildren
  '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro': typeof WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history': typeof WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/tasks': typeof WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/': typeof WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/assinaturas': typeof AssinaturasRoute
  '/invites': typeof InvitesRoute
  '/login': typeof LoginRoute
  '/politica-cancelamento-reembolso': typeof PoliticaCancelamentoReembolsoRoute
  '/politica-privacidade-cookies': typeof PoliticaPrivacidadeCookiesRoute
  '/prometeus': typeof PrometeusRoute
  '/settings': typeof SettingsRoute
  '/termos': typeof TermosRoute
  '/workspaces': typeof WorkspacesRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/client/invites': typeof ClientInvitesRoute
  '/community/connections': typeof CommunityConnectionsRoute
  '/community/feed': typeof CommunityFeedRoute
  '/community/search': typeof CommunitySearchRoute
  '/register-client-invite/$token': typeof RegisterClientInviteTokenRoute
  '/register-invite/$token': typeof RegisterInviteTokenRoute
  '/certificacao': typeof CertificacaoIndexRoute
  '/client': typeof ClientIndexRoute
  '/community': typeof CommunityIndexRoute
  '/admin/workspace/$workspaceId': typeof AdminWorkspaceWorkspaceIdRoute
  '/certificacao/certificados/$id': typeof CertificacaoCertificadosIdRoute
  '/community/articles/$articleId': typeof CommunityArticlesArticleIdRoute
  '/community/articles/new': typeof CommunityArticlesNewRoute
  '/community/jobs/$jobId': typeof CommunityJobsJobIdRoute
  '/community/jobs/new': typeof CommunityJobsNewRoute
  '/community/profile/$userId': typeof CommunityProfileUserIdRoute
  '/community/profile/edit': typeof CommunityProfileEditRoute
  '/w/$workspaceId/agenda': typeof WWorkspaceIdAgendaRoute
  '/w/$workspaceId/certificacoes': typeof WWorkspaceIdCertificacoesRoute
  '/w/$workspaceId/chat': typeof WWorkspaceIdChatRoute
  '/w/$workspaceId/client-invites': typeof WWorkspaceIdClientInvitesRoute
  '/w/$workspaceId/clients': typeof WWorkspaceIdClientsRouteWithChildren
  '/w/$workspaceId/documents': typeof WWorkspaceIdDocumentsRoute
  '/w/$workspaceId/gamification': typeof WWorkspaceIdGamificationRoute
  '/w/$workspaceId/metrics': typeof WWorkspaceIdMetricsRoute
  '/w/$workspaceId/notifications': typeof WWorkspaceIdNotificationsRoute
  '/w/$workspaceId/plan': typeof WWorkspaceIdPlanRoute
  '/w/$workspaceId/publications': typeof WWorkspaceIdPublicationsRoute
  '/w/$workspaceId/shop': typeof WWorkspaceIdShopRoute
  '/w/$workspaceId/tasks': typeof WWorkspaceIdTasksRoute
  '/community/jobs': typeof CommunityJobsIndexRoute
  '/admin/tribunais/$tribunalId/calibracao': typeof AdminTribunaisTribunalIdCalibracaoRoute
  '/certificacao/cursos/$courseId/simulado': typeof CertificacaoCursosCourseIdSimuladoRoute
  '/client/processes/$processId/sync-history': typeof ClientProcessesProcessIdSyncHistoryRoute
  '/client/processes/$processId/tasks': typeof ClientProcessesProcessIdTasksRoute
  '/w/$workspaceId/clients/$clientId': typeof WWorkspaceIdClientsClientIdRouteWithChildren
  '/w/$workspaceId/clients/new': typeof WWorkspaceIdClientsNewRoute
  '/w/$workspaceId/financeiro/configuracoes': typeof WWorkspaceIdFinanceiroConfiguracoesRoute
  '/w/$workspaceId/financeiro/contas-pagar': typeof WWorkspaceIdFinanceiroContasPagarRoute
  '/w/$workspaceId/financeiro/contas-receber': typeof WWorkspaceIdFinanceiroContasReceberRoute
  '/w/$workspaceId/financeiro/fluxo': typeof WWorkspaceIdFinanceiroFluxoRoute
  '/w/$workspaceId/financeiro/importacao': typeof WWorkspaceIdFinanceiroImportacaoRoute
  '/w/$workspaceId/financeiro/lancamentos': typeof WWorkspaceIdFinanceiroLancamentosRoute
  '/w/$workspaceId/financeiro/pendencias': typeof WWorkspaceIdFinanceiroPendenciasRoute
  '/w/$workspaceId/financeiro/previsao-sucumbencia': typeof WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute
  '/w/$workspaceId/financeiro/resumo': typeof WWorkspaceIdFinanceiroResumoRoute
  '/w/$workspaceId/processes/external-search': typeof WWorkspaceIdProcessesExternalSearchRoute
  '/w/$workspaceId/processes/external-search-details': typeof WWorkspaceIdProcessesExternalSearchDetailsRoute
  '/w/$workspaceId/settings/certifications': typeof WWorkspaceIdSettingsCertificationsRoute
  '/w/$workspaceId/settings/gamification': typeof WWorkspaceIdSettingsGamificationRoute
  '/w/$workspaceId/settings/members': typeof WWorkspaceIdSettingsMembersRoute
  '/w/$workspaceId/settings/roles': typeof WWorkspaceIdSettingsRolesRoute
  '/w/$workspaceId/settings/tags': typeof WWorkspaceIdSettingsTagsRoute
  '/w/$workspaceId/settings/termos': typeof WWorkspaceIdSettingsTermosRoute
  '/w/$workspaceId/settings/work-groups': typeof WWorkspaceIdSettingsWorkGroupsRoute
  '/w/$workspaceId/settings/workflow-presets': typeof WWorkspaceIdSettingsWorkflowPresetsRoute
  '/w/$workspaceId/workflow-presets/$presetId': typeof WWorkspaceIdWorkflowPresetsPresetIdRoute
  '/certificacao/cursos/$courseId': typeof CertificacaoCursosCourseIdIndexRoute
  '/client/processes/$processId': typeof ClientProcessesProcessIdIndexRoute
  '/w/$workspaceId/financeiro': typeof WWorkspaceIdFinanceiroIndexRoute
  '/w/$workspaceId/workflow-presets': typeof WWorkspaceIdWorkflowPresetsIndexRoute
  '/certificacao/cursos/$courseId/etapa/$stepId': typeof CertificacaoCursosCourseIdEtapaStepIdRoute
  '/w/$workspaceId/clients/$clientId/documents': typeof WWorkspaceIdClientsClientIdDocumentsRoute
  '/w/$workspaceId/clients/$clientId/processes': typeof WWorkspaceIdClientsClientIdProcessesRouteWithChildren
  '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro': typeof WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history': typeof WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/tasks': typeof WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId': typeof WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/assinaturas': typeof AssinaturasRoute
  '/certificacao': typeof CertificacaoRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/community': typeof CommunityRouteWithChildren
  '/invites': typeof InvitesRoute
  '/login': typeof LoginRoute
  '/politica-cancelamento-reembolso': typeof PoliticaCancelamentoReembolsoRoute
  '/politica-privacidade-cookies': typeof PoliticaPrivacidadeCookiesRoute
  '/prometeus': typeof PrometeusRoute
  '/settings': typeof SettingsRoute
  '/termos': typeof TermosRoute
  '/workspaces': typeof WorkspacesRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/client/invites': typeof ClientInvitesRoute
  '/community/connections': typeof CommunityConnectionsRoute
  '/community/feed': typeof CommunityFeedRoute
  '/community/jobs': typeof CommunityJobsRouteWithChildren
  '/community/search': typeof CommunitySearchRoute
  '/register-client-invite/$token': typeof RegisterClientInviteTokenRoute
  '/register-invite/$token': typeof RegisterInviteTokenRoute
  '/certificacao/': typeof CertificacaoIndexRoute
  '/client/': typeof ClientIndexRoute
  '/community/': typeof CommunityIndexRoute
  '/admin/workspace/$workspaceId': typeof AdminWorkspaceWorkspaceIdRoute
  '/certificacao/certificados/$id': typeof CertificacaoCertificadosIdRoute
  '/certificacao/cursos/$courseId': typeof CertificacaoCursosCourseIdRouteWithChildren
  '/client/processes/$processId': typeof ClientProcessesProcessIdRouteWithChildren
  '/community/articles/$articleId': typeof CommunityArticlesArticleIdRoute
  '/community/articles/new': typeof CommunityArticlesNewRoute
  '/community/jobs/$jobId': typeof CommunityJobsJobIdRoute
  '/community/jobs/new': typeof CommunityJobsNewRoute
  '/community/profile/$userId': typeof CommunityProfileUserIdRoute
  '/community/profile/edit': typeof CommunityProfileEditRoute
  '/w/$workspaceId/agenda': typeof WWorkspaceIdAgendaRoute
  '/w/$workspaceId/certificacoes': typeof WWorkspaceIdCertificacoesRoute
  '/w/$workspaceId/chat': typeof WWorkspaceIdChatRoute
  '/w/$workspaceId/client-invites': typeof WWorkspaceIdClientInvitesRoute
  '/w/$workspaceId/clients': typeof WWorkspaceIdClientsRouteWithChildren
  '/w/$workspaceId/documents': typeof WWorkspaceIdDocumentsRoute
  '/w/$workspaceId/financeiro': typeof WWorkspaceIdFinanceiroRouteWithChildren
  '/w/$workspaceId/gamification': typeof WWorkspaceIdGamificationRoute
  '/w/$workspaceId/metrics': typeof WWorkspaceIdMetricsRoute
  '/w/$workspaceId/notifications': typeof WWorkspaceIdNotificationsRoute
  '/w/$workspaceId/plan': typeof WWorkspaceIdPlanRoute
  '/w/$workspaceId/publications': typeof WWorkspaceIdPublicationsRoute
  '/w/$workspaceId/shop': typeof WWorkspaceIdShopRoute
  '/w/$workspaceId/tasks': typeof WWorkspaceIdTasksRoute
  '/w/$workspaceId/workflow-presets': typeof WWorkspaceIdWorkflowPresetsRouteWithChildren
  '/community/jobs/': typeof CommunityJobsIndexRoute
  '/admin/tribunais/$tribunalId/calibracao': typeof AdminTribunaisTribunalIdCalibracaoRoute
  '/certificacao/cursos/$courseId/simulado': typeof CertificacaoCursosCourseIdSimuladoRoute
  '/client/processes/$processId/sync-history': typeof ClientProcessesProcessIdSyncHistoryRoute
  '/client/processes/$processId/tasks': typeof ClientProcessesProcessIdTasksRoute
  '/w/$workspaceId/clients/$clientId': typeof WWorkspaceIdClientsClientIdRouteWithChildren
  '/w/$workspaceId/clients/new': typeof WWorkspaceIdClientsNewRoute
  '/w/$workspaceId/financeiro/configuracoes': typeof WWorkspaceIdFinanceiroConfiguracoesRoute
  '/w/$workspaceId/financeiro/contas-pagar': typeof WWorkspaceIdFinanceiroContasPagarRoute
  '/w/$workspaceId/financeiro/contas-receber': typeof WWorkspaceIdFinanceiroContasReceberRoute
  '/w/$workspaceId/financeiro/fluxo': typeof WWorkspaceIdFinanceiroFluxoRoute
  '/w/$workspaceId/financeiro/importacao': typeof WWorkspaceIdFinanceiroImportacaoRoute
  '/w/$workspaceId/financeiro/lancamentos': typeof WWorkspaceIdFinanceiroLancamentosRoute
  '/w/$workspaceId/financeiro/pendencias': typeof WWorkspaceIdFinanceiroPendenciasRoute
  '/w/$workspaceId/financeiro/previsao-sucumbencia': typeof WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute
  '/w/$workspaceId/financeiro/resumo': typeof WWorkspaceIdFinanceiroResumoRoute
  '/w/$workspaceId/processes/external-search': typeof WWorkspaceIdProcessesExternalSearchRoute
  '/w/$workspaceId/processes/external-search-details': typeof WWorkspaceIdProcessesExternalSearchDetailsRoute
  '/w/$workspaceId/settings/certifications': typeof WWorkspaceIdSettingsCertificationsRoute
  '/w/$workspaceId/settings/gamification': typeof WWorkspaceIdSettingsGamificationRoute
  '/w/$workspaceId/settings/members': typeof WWorkspaceIdSettingsMembersRoute
  '/w/$workspaceId/settings/roles': typeof WWorkspaceIdSettingsRolesRoute
  '/w/$workspaceId/settings/tags': typeof WWorkspaceIdSettingsTagsRoute
  '/w/$workspaceId/settings/termos': typeof WWorkspaceIdSettingsTermosRoute
  '/w/$workspaceId/settings/work-groups': typeof WWorkspaceIdSettingsWorkGroupsRoute
  '/w/$workspaceId/settings/workflow-presets': typeof WWorkspaceIdSettingsWorkflowPresetsRoute
  '/w/$workspaceId/workflow-presets/$presetId': typeof WWorkspaceIdWorkflowPresetsPresetIdRoute
  '/certificacao/cursos/$courseId/': typeof CertificacaoCursosCourseIdIndexRoute
  '/client/processes/$processId/': typeof ClientProcessesProcessIdIndexRoute
  '/w/$workspaceId/financeiro/': typeof WWorkspaceIdFinanceiroIndexRoute
  '/w/$workspaceId/workflow-presets/': typeof WWorkspaceIdWorkflowPresetsIndexRoute
  '/certificacao/cursos/$courseId/etapa/$stepId': typeof CertificacaoCursosCourseIdEtapaStepIdRoute
  '/w/$workspaceId/clients/$clientId/documents': typeof WWorkspaceIdClientsClientIdDocumentsRoute
  '/w/$workspaceId/clients/$clientId/processes': typeof WWorkspaceIdClientsClientIdProcessesRouteWithChildren
  '/w/$workspaceId/clients/$clientId/processes/$processId': typeof WWorkspaceIdClientsClientIdProcessesProcessIdRouteWithChildren
  '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro': typeof WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history': typeof WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/tasks': typeof WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute
  '/w/$workspaceId/clients/$clientId/processes/$processId/': typeof WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/assinaturas'
    | '/certificacao'
    | '/client'
    | '/community'
    | '/invites'
    | '/login'
    | '/politica-cancelamento-reembolso'
    | '/politica-privacidade-cookies'
    | '/prometeus'
    | '/settings'
    | '/termos'
    | '/workspaces'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/client/invites'
    | '/community/connections'
    | '/community/feed'
    | '/community/jobs'
    | '/community/search'
    | '/register-client-invite/$token'
    | '/register-invite/$token'
    | '/certificacao/'
    | '/client/'
    | '/community/'
    | '/admin/workspace/$workspaceId'
    | '/certificacao/certificados/$id'
    | '/certificacao/cursos/$courseId'
    | '/client/processes/$processId'
    | '/community/articles/$articleId'
    | '/community/articles/new'
    | '/community/jobs/$jobId'
    | '/community/jobs/new'
    | '/community/profile/$userId'
    | '/community/profile/edit'
    | '/w/$workspaceId/agenda'
    | '/w/$workspaceId/certificacoes'
    | '/w/$workspaceId/chat'
    | '/w/$workspaceId/client-invites'
    | '/w/$workspaceId/clients'
    | '/w/$workspaceId/documents'
    | '/w/$workspaceId/financeiro'
    | '/w/$workspaceId/gamification'
    | '/w/$workspaceId/metrics'
    | '/w/$workspaceId/notifications'
    | '/w/$workspaceId/plan'
    | '/w/$workspaceId/publications'
    | '/w/$workspaceId/shop'
    | '/w/$workspaceId/tasks'
    | '/w/$workspaceId/workflow-presets'
    | '/community/jobs/'
    | '/admin/tribunais/$tribunalId/calibracao'
    | '/certificacao/cursos/$courseId/simulado'
    | '/client/processes/$processId/sync-history'
    | '/client/processes/$processId/tasks'
    | '/w/$workspaceId/clients/$clientId'
    | '/w/$workspaceId/clients/new'
    | '/w/$workspaceId/financeiro/configuracoes'
    | '/w/$workspaceId/financeiro/contas-pagar'
    | '/w/$workspaceId/financeiro/contas-receber'
    | '/w/$workspaceId/financeiro/fluxo'
    | '/w/$workspaceId/financeiro/importacao'
    | '/w/$workspaceId/financeiro/lancamentos'
    | '/w/$workspaceId/financeiro/pendencias'
    | '/w/$workspaceId/financeiro/previsao-sucumbencia'
    | '/w/$workspaceId/financeiro/resumo'
    | '/w/$workspaceId/processes/external-search'
    | '/w/$workspaceId/processes/external-search-details'
    | '/w/$workspaceId/settings/certifications'
    | '/w/$workspaceId/settings/gamification'
    | '/w/$workspaceId/settings/members'
    | '/w/$workspaceId/settings/roles'
    | '/w/$workspaceId/settings/tags'
    | '/w/$workspaceId/settings/termos'
    | '/w/$workspaceId/settings/work-groups'
    | '/w/$workspaceId/settings/workflow-presets'
    | '/w/$workspaceId/workflow-presets/$presetId'
    | '/certificacao/cursos/$courseId/'
    | '/client/processes/$processId/'
    | '/w/$workspaceId/financeiro/'
    | '/w/$workspaceId/workflow-presets/'
    | '/certificacao/cursos/$courseId/etapa/$stepId'
    | '/w/$workspaceId/clients/$clientId/documents'
    | '/w/$workspaceId/clients/$clientId/processes'
    | '/w/$workspaceId/clients/$clientId/processes/$processId'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/tasks'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/assinaturas'
    | '/invites'
    | '/login'
    | '/politica-cancelamento-reembolso'
    | '/politica-privacidade-cookies'
    | '/prometeus'
    | '/settings'
    | '/termos'
    | '/workspaces'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/client/invites'
    | '/community/connections'
    | '/community/feed'
    | '/community/search'
    | '/register-client-invite/$token'
    | '/register-invite/$token'
    | '/certificacao'
    | '/client'
    | '/community'
    | '/admin/workspace/$workspaceId'
    | '/certificacao/certificados/$id'
    | '/community/articles/$articleId'
    | '/community/articles/new'
    | '/community/jobs/$jobId'
    | '/community/jobs/new'
    | '/community/profile/$userId'
    | '/community/profile/edit'
    | '/w/$workspaceId/agenda'
    | '/w/$workspaceId/certificacoes'
    | '/w/$workspaceId/chat'
    | '/w/$workspaceId/client-invites'
    | '/w/$workspaceId/clients'
    | '/w/$workspaceId/documents'
    | '/w/$workspaceId/gamification'
    | '/w/$workspaceId/metrics'
    | '/w/$workspaceId/notifications'
    | '/w/$workspaceId/plan'
    | '/w/$workspaceId/publications'
    | '/w/$workspaceId/shop'
    | '/w/$workspaceId/tasks'
    | '/community/jobs'
    | '/admin/tribunais/$tribunalId/calibracao'
    | '/certificacao/cursos/$courseId/simulado'
    | '/client/processes/$processId/sync-history'
    | '/client/processes/$processId/tasks'
    | '/w/$workspaceId/clients/$clientId'
    | '/w/$workspaceId/clients/new'
    | '/w/$workspaceId/financeiro/configuracoes'
    | '/w/$workspaceId/financeiro/contas-pagar'
    | '/w/$workspaceId/financeiro/contas-receber'
    | '/w/$workspaceId/financeiro/fluxo'
    | '/w/$workspaceId/financeiro/importacao'
    | '/w/$workspaceId/financeiro/lancamentos'
    | '/w/$workspaceId/financeiro/pendencias'
    | '/w/$workspaceId/financeiro/previsao-sucumbencia'
    | '/w/$workspaceId/financeiro/resumo'
    | '/w/$workspaceId/processes/external-search'
    | '/w/$workspaceId/processes/external-search-details'
    | '/w/$workspaceId/settings/certifications'
    | '/w/$workspaceId/settings/gamification'
    | '/w/$workspaceId/settings/members'
    | '/w/$workspaceId/settings/roles'
    | '/w/$workspaceId/settings/tags'
    | '/w/$workspaceId/settings/termos'
    | '/w/$workspaceId/settings/work-groups'
    | '/w/$workspaceId/settings/workflow-presets'
    | '/w/$workspaceId/workflow-presets/$presetId'
    | '/certificacao/cursos/$courseId'
    | '/client/processes/$processId'
    | '/w/$workspaceId/financeiro'
    | '/w/$workspaceId/workflow-presets'
    | '/certificacao/cursos/$courseId/etapa/$stepId'
    | '/w/$workspaceId/clients/$clientId/documents'
    | '/w/$workspaceId/clients/$clientId/processes'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/tasks'
    | '/w/$workspaceId/clients/$clientId/processes/$processId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/assinaturas'
    | '/certificacao'
    | '/client'
    | '/community'
    | '/invites'
    | '/login'
    | '/politica-cancelamento-reembolso'
    | '/politica-privacidade-cookies'
    | '/prometeus'
    | '/settings'
    | '/termos'
    | '/workspaces'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/client/invites'
    | '/community/connections'
    | '/community/feed'
    | '/community/jobs'
    | '/community/search'
    | '/register-client-invite/$token'
    | '/register-invite/$token'
    | '/certificacao/'
    | '/client/'
    | '/community/'
    | '/admin/workspace/$workspaceId'
    | '/certificacao/certificados/$id'
    | '/certificacao/cursos/$courseId'
    | '/client/processes/$processId'
    | '/community/articles/$articleId'
    | '/community/articles/new'
    | '/community/jobs/$jobId'
    | '/community/jobs/new'
    | '/community/profile/$userId'
    | '/community/profile/edit'
    | '/w/$workspaceId/agenda'
    | '/w/$workspaceId/certificacoes'
    | '/w/$workspaceId/chat'
    | '/w/$workspaceId/client-invites'
    | '/w/$workspaceId/clients'
    | '/w/$workspaceId/documents'
    | '/w/$workspaceId/financeiro'
    | '/w/$workspaceId/gamification'
    | '/w/$workspaceId/metrics'
    | '/w/$workspaceId/notifications'
    | '/w/$workspaceId/plan'
    | '/w/$workspaceId/publications'
    | '/w/$workspaceId/shop'
    | '/w/$workspaceId/tasks'
    | '/w/$workspaceId/workflow-presets'
    | '/community/jobs/'
    | '/admin/tribunais/$tribunalId/calibracao'
    | '/certificacao/cursos/$courseId/simulado'
    | '/client/processes/$processId/sync-history'
    | '/client/processes/$processId/tasks'
    | '/w/$workspaceId/clients/$clientId'
    | '/w/$workspaceId/clients/new'
    | '/w/$workspaceId/financeiro/configuracoes'
    | '/w/$workspaceId/financeiro/contas-pagar'
    | '/w/$workspaceId/financeiro/contas-receber'
    | '/w/$workspaceId/financeiro/fluxo'
    | '/w/$workspaceId/financeiro/importacao'
    | '/w/$workspaceId/financeiro/lancamentos'
    | '/w/$workspaceId/financeiro/pendencias'
    | '/w/$workspaceId/financeiro/previsao-sucumbencia'
    | '/w/$workspaceId/financeiro/resumo'
    | '/w/$workspaceId/processes/external-search'
    | '/w/$workspaceId/processes/external-search-details'
    | '/w/$workspaceId/settings/certifications'
    | '/w/$workspaceId/settings/gamification'
    | '/w/$workspaceId/settings/members'
    | '/w/$workspaceId/settings/roles'
    | '/w/$workspaceId/settings/tags'
    | '/w/$workspaceId/settings/termos'
    | '/w/$workspaceId/settings/work-groups'
    | '/w/$workspaceId/settings/workflow-presets'
    | '/w/$workspaceId/workflow-presets/$presetId'
    | '/certificacao/cursos/$courseId/'
    | '/client/processes/$processId/'
    | '/w/$workspaceId/financeiro/'
    | '/w/$workspaceId/workflow-presets/'
    | '/certificacao/cursos/$courseId/etapa/$stepId'
    | '/w/$workspaceId/clients/$clientId/documents'
    | '/w/$workspaceId/clients/$clientId/processes'
    | '/w/$workspaceId/clients/$clientId/processes/$processId'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/tasks'
    | '/w/$workspaceId/clients/$clientId/processes/$processId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AssinaturasRoute: typeof AssinaturasRoute
  CertificacaoRoute: typeof CertificacaoRouteWithChildren
  ClientRoute: typeof ClientRouteWithChildren
  CommunityRoute: typeof CommunityRouteWithChildren
  InvitesRoute: typeof InvitesRoute
  LoginRoute: typeof LoginRoute
  PoliticaCancelamentoReembolsoRoute: typeof PoliticaCancelamentoReembolsoRoute
  PoliticaPrivacidadeCookiesRoute: typeof PoliticaPrivacidadeCookiesRoute
  PrometeusRoute: typeof PrometeusRoute
  SettingsRoute: typeof SettingsRoute
  TermosRoute: typeof TermosRoute
  WorkspacesRoute: typeof WorkspacesRoute
  CheckoutCancelRoute: typeof CheckoutCancelRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  RegisterClientInviteTokenRoute: typeof RegisterClientInviteTokenRoute
  RegisterInviteTokenRoute: typeof RegisterInviteTokenRoute
  WWorkspaceIdAgendaRoute: typeof WWorkspaceIdAgendaRoute
  WWorkspaceIdCertificacoesRoute: typeof WWorkspaceIdCertificacoesRoute
  WWorkspaceIdChatRoute: typeof WWorkspaceIdChatRoute
  WWorkspaceIdClientInvitesRoute: typeof WWorkspaceIdClientInvitesRoute
  WWorkspaceIdClientsRoute: typeof WWorkspaceIdClientsRouteWithChildren
  WWorkspaceIdDocumentsRoute: typeof WWorkspaceIdDocumentsRoute
  WWorkspaceIdFinanceiroRoute: typeof WWorkspaceIdFinanceiroRouteWithChildren
  WWorkspaceIdGamificationRoute: typeof WWorkspaceIdGamificationRoute
  WWorkspaceIdMetricsRoute: typeof WWorkspaceIdMetricsRoute
  WWorkspaceIdNotificationsRoute: typeof WWorkspaceIdNotificationsRoute
  WWorkspaceIdPlanRoute: typeof WWorkspaceIdPlanRoute
  WWorkspaceIdPublicationsRoute: typeof WWorkspaceIdPublicationsRoute
  WWorkspaceIdShopRoute: typeof WWorkspaceIdShopRoute
  WWorkspaceIdTasksRoute: typeof WWorkspaceIdTasksRoute
  WWorkspaceIdWorkflowPresetsRoute: typeof WWorkspaceIdWorkflowPresetsRouteWithChildren
  WWorkspaceIdProcessesExternalSearchRoute: typeof WWorkspaceIdProcessesExternalSearchRoute
  WWorkspaceIdProcessesExternalSearchDetailsRoute: typeof WWorkspaceIdProcessesExternalSearchDetailsRoute
  WWorkspaceIdSettingsCertificationsRoute: typeof WWorkspaceIdSettingsCertificationsRoute
  WWorkspaceIdSettingsGamificationRoute: typeof WWorkspaceIdSettingsGamificationRoute
  WWorkspaceIdSettingsMembersRoute: typeof WWorkspaceIdSettingsMembersRoute
  WWorkspaceIdSettingsRolesRoute: typeof WWorkspaceIdSettingsRolesRoute
  WWorkspaceIdSettingsTagsRoute: typeof WWorkspaceIdSettingsTagsRoute
  WWorkspaceIdSettingsTermosRoute: typeof WWorkspaceIdSettingsTermosRoute
  WWorkspaceIdSettingsWorkGroupsRoute: typeof WWorkspaceIdSettingsWorkGroupsRoute
  WWorkspaceIdSettingsWorkflowPresetsRoute: typeof WWorkspaceIdSettingsWorkflowPresetsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspaces': {
      id: '/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WorkspacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prometeus': {
      id: '/prometeus'
      path: '/prometeus'
      fullPath: '/prometeus'
      preLoaderRoute: typeof PrometeusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-privacidade-cookies': {
      id: '/politica-privacidade-cookies'
      path: '/politica-privacidade-cookies'
      fullPath: '/politica-privacidade-cookies'
      preLoaderRoute: typeof PoliticaPrivacidadeCookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-cancelamento-reembolso': {
      id: '/politica-cancelamento-reembolso'
      path: '/politica-cancelamento-reembolso'
      fullPath: '/politica-cancelamento-reembolso'
      preLoaderRoute: typeof PoliticaCancelamentoReembolsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites': {
      id: '/invites'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof InvitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client': {
      id: '/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof ClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certificacao': {
      id: '/certificacao'
      path: '/certificacao'
      fullPath: '/certificacao'
      preLoaderRoute: typeof CertificacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assinaturas': {
      id: '/assinaturas'
      path: '/assinaturas'
      fullPath: '/assinaturas'
      preLoaderRoute: typeof AssinaturasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community/': {
      id: '/community/'
      path: '/'
      fullPath: '/community/'
      preLoaderRoute: typeof CommunityIndexRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/client/': {
      id: '/client/'
      path: '/'
      fullPath: '/client/'
      preLoaderRoute: typeof ClientIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/certificacao/': {
      id: '/certificacao/'
      path: '/'
      fullPath: '/certificacao/'
      preLoaderRoute: typeof CertificacaoIndexRouteImport
      parentRoute: typeof CertificacaoRoute
    }
    '/register-invite/$token': {
      id: '/register-invite/$token'
      path: '/register-invite/$token'
      fullPath: '/register-invite/$token'
      preLoaderRoute: typeof RegisterInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register-client-invite/$token': {
      id: '/register-client-invite/$token'
      path: '/register-client-invite/$token'
      fullPath: '/register-client-invite/$token'
      preLoaderRoute: typeof RegisterClientInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community/search': {
      id: '/community/search'
      path: '/search'
      fullPath: '/community/search'
      preLoaderRoute: typeof CommunitySearchRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/community/jobs': {
      id: '/community/jobs'
      path: '/jobs'
      fullPath: '/community/jobs'
      preLoaderRoute: typeof CommunityJobsRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/community/feed': {
      id: '/community/feed'
      path: '/feed'
      fullPath: '/community/feed'
      preLoaderRoute: typeof CommunityFeedRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/community/connections': {
      id: '/community/connections'
      path: '/connections'
      fullPath: '/community/connections'
      preLoaderRoute: typeof CommunityConnectionsRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/client/invites': {
      id: '/client/invites'
      path: '/invites'
      fullPath: '/client/invites'
      preLoaderRoute: typeof ClientInvitesRouteImport
      parentRoute: typeof ClientRoute
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/cancel': {
      id: '/checkout/cancel'
      path: '/checkout/cancel'
      fullPath: '/checkout/cancel'
      preLoaderRoute: typeof CheckoutCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community/jobs/': {
      id: '/community/jobs/'
      path: '/'
      fullPath: '/community/jobs/'
      preLoaderRoute: typeof CommunityJobsIndexRouteImport
      parentRoute: typeof CommunityJobsRoute
    }
    '/w/$workspaceId/workflow-presets': {
      id: '/w/$workspaceId/workflow-presets'
      path: '/w/$workspaceId/workflow-presets'
      fullPath: '/w/$workspaceId/workflow-presets'
      preLoaderRoute: typeof WWorkspaceIdWorkflowPresetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/tasks': {
      id: '/w/$workspaceId/tasks'
      path: '/w/$workspaceId/tasks'
      fullPath: '/w/$workspaceId/tasks'
      preLoaderRoute: typeof WWorkspaceIdTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/shop': {
      id: '/w/$workspaceId/shop'
      path: '/w/$workspaceId/shop'
      fullPath: '/w/$workspaceId/shop'
      preLoaderRoute: typeof WWorkspaceIdShopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/publications': {
      id: '/w/$workspaceId/publications'
      path: '/w/$workspaceId/publications'
      fullPath: '/w/$workspaceId/publications'
      preLoaderRoute: typeof WWorkspaceIdPublicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/plan': {
      id: '/w/$workspaceId/plan'
      path: '/w/$workspaceId/plan'
      fullPath: '/w/$workspaceId/plan'
      preLoaderRoute: typeof WWorkspaceIdPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/notifications': {
      id: '/w/$workspaceId/notifications'
      path: '/w/$workspaceId/notifications'
      fullPath: '/w/$workspaceId/notifications'
      preLoaderRoute: typeof WWorkspaceIdNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/metrics': {
      id: '/w/$workspaceId/metrics'
      path: '/w/$workspaceId/metrics'
      fullPath: '/w/$workspaceId/metrics'
      preLoaderRoute: typeof WWorkspaceIdMetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/gamification': {
      id: '/w/$workspaceId/gamification'
      path: '/w/$workspaceId/gamification'
      fullPath: '/w/$workspaceId/gamification'
      preLoaderRoute: typeof WWorkspaceIdGamificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/financeiro': {
      id: '/w/$workspaceId/financeiro'
      path: '/w/$workspaceId/financeiro'
      fullPath: '/w/$workspaceId/financeiro'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/documents': {
      id: '/w/$workspaceId/documents'
      path: '/w/$workspaceId/documents'
      fullPath: '/w/$workspaceId/documents'
      preLoaderRoute: typeof WWorkspaceIdDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/clients': {
      id: '/w/$workspaceId/clients'
      path: '/w/$workspaceId/clients'
      fullPath: '/w/$workspaceId/clients'
      preLoaderRoute: typeof WWorkspaceIdClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/client-invites': {
      id: '/w/$workspaceId/client-invites'
      path: '/w/$workspaceId/client-invites'
      fullPath: '/w/$workspaceId/client-invites'
      preLoaderRoute: typeof WWorkspaceIdClientInvitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/chat': {
      id: '/w/$workspaceId/chat'
      path: '/w/$workspaceId/chat'
      fullPath: '/w/$workspaceId/chat'
      preLoaderRoute: typeof WWorkspaceIdChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/certificacoes': {
      id: '/w/$workspaceId/certificacoes'
      path: '/w/$workspaceId/certificacoes'
      fullPath: '/w/$workspaceId/certificacoes'
      preLoaderRoute: typeof WWorkspaceIdCertificacoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/agenda': {
      id: '/w/$workspaceId/agenda'
      path: '/w/$workspaceId/agenda'
      fullPath: '/w/$workspaceId/agenda'
      preLoaderRoute: typeof WWorkspaceIdAgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community/profile/edit': {
      id: '/community/profile/edit'
      path: '/profile/edit'
      fullPath: '/community/profile/edit'
      preLoaderRoute: typeof CommunityProfileEditRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/community/profile/$userId': {
      id: '/community/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/community/profile/$userId'
      preLoaderRoute: typeof CommunityProfileUserIdRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/community/jobs/new': {
      id: '/community/jobs/new'
      path: '/new'
      fullPath: '/community/jobs/new'
      preLoaderRoute: typeof CommunityJobsNewRouteImport
      parentRoute: typeof CommunityJobsRoute
    }
    '/community/jobs/$jobId': {
      id: '/community/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/community/jobs/$jobId'
      preLoaderRoute: typeof CommunityJobsJobIdRouteImport
      parentRoute: typeof CommunityJobsRoute
    }
    '/community/articles/new': {
      id: '/community/articles/new'
      path: '/articles/new'
      fullPath: '/community/articles/new'
      preLoaderRoute: typeof CommunityArticlesNewRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/community/articles/$articleId': {
      id: '/community/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/community/articles/$articleId'
      preLoaderRoute: typeof CommunityArticlesArticleIdRouteImport
      parentRoute: typeof CommunityRoute
    }
    '/client/processes/$processId': {
      id: '/client/processes/$processId'
      path: '/processes/$processId'
      fullPath: '/client/processes/$processId'
      preLoaderRoute: typeof ClientProcessesProcessIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/certificacao/cursos/$courseId': {
      id: '/certificacao/cursos/$courseId'
      path: '/cursos/$courseId'
      fullPath: '/certificacao/cursos/$courseId'
      preLoaderRoute: typeof CertificacaoCursosCourseIdRouteImport
      parentRoute: typeof CertificacaoRoute
    }
    '/certificacao/certificados/$id': {
      id: '/certificacao/certificados/$id'
      path: '/certificados/$id'
      fullPath: '/certificacao/certificados/$id'
      preLoaderRoute: typeof CertificacaoCertificadosIdRouteImport
      parentRoute: typeof CertificacaoRoute
    }
    '/admin/workspace/$workspaceId': {
      id: '/admin/workspace/$workspaceId'
      path: '/workspace/$workspaceId'
      fullPath: '/admin/workspace/$workspaceId'
      preLoaderRoute: typeof AdminWorkspaceWorkspaceIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/w/$workspaceId/workflow-presets/': {
      id: '/w/$workspaceId/workflow-presets/'
      path: '/'
      fullPath: '/w/$workspaceId/workflow-presets/'
      preLoaderRoute: typeof WWorkspaceIdWorkflowPresetsIndexRouteImport
      parentRoute: typeof WWorkspaceIdWorkflowPresetsRoute
    }
    '/w/$workspaceId/financeiro/': {
      id: '/w/$workspaceId/financeiro/'
      path: '/'
      fullPath: '/w/$workspaceId/financeiro/'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroIndexRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/client/processes/$processId/': {
      id: '/client/processes/$processId/'
      path: '/'
      fullPath: '/client/processes/$processId/'
      preLoaderRoute: typeof ClientProcessesProcessIdIndexRouteImport
      parentRoute: typeof ClientProcessesProcessIdRoute
    }
    '/certificacao/cursos/$courseId/': {
      id: '/certificacao/cursos/$courseId/'
      path: '/'
      fullPath: '/certificacao/cursos/$courseId/'
      preLoaderRoute: typeof CertificacaoCursosCourseIdIndexRouteImport
      parentRoute: typeof CertificacaoCursosCourseIdRoute
    }
    '/w/$workspaceId/workflow-presets/$presetId': {
      id: '/w/$workspaceId/workflow-presets/$presetId'
      path: '/$presetId'
      fullPath: '/w/$workspaceId/workflow-presets/$presetId'
      preLoaderRoute: typeof WWorkspaceIdWorkflowPresetsPresetIdRouteImport
      parentRoute: typeof WWorkspaceIdWorkflowPresetsRoute
    }
    '/w/$workspaceId/settings/workflow-presets': {
      id: '/w/$workspaceId/settings/workflow-presets'
      path: '/w/$workspaceId/settings/workflow-presets'
      fullPath: '/w/$workspaceId/settings/workflow-presets'
      preLoaderRoute: typeof WWorkspaceIdSettingsWorkflowPresetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/work-groups': {
      id: '/w/$workspaceId/settings/work-groups'
      path: '/w/$workspaceId/settings/work-groups'
      fullPath: '/w/$workspaceId/settings/work-groups'
      preLoaderRoute: typeof WWorkspaceIdSettingsWorkGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/termos': {
      id: '/w/$workspaceId/settings/termos'
      path: '/w/$workspaceId/settings/termos'
      fullPath: '/w/$workspaceId/settings/termos'
      preLoaderRoute: typeof WWorkspaceIdSettingsTermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/tags': {
      id: '/w/$workspaceId/settings/tags'
      path: '/w/$workspaceId/settings/tags'
      fullPath: '/w/$workspaceId/settings/tags'
      preLoaderRoute: typeof WWorkspaceIdSettingsTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/roles': {
      id: '/w/$workspaceId/settings/roles'
      path: '/w/$workspaceId/settings/roles'
      fullPath: '/w/$workspaceId/settings/roles'
      preLoaderRoute: typeof WWorkspaceIdSettingsRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/members': {
      id: '/w/$workspaceId/settings/members'
      path: '/w/$workspaceId/settings/members'
      fullPath: '/w/$workspaceId/settings/members'
      preLoaderRoute: typeof WWorkspaceIdSettingsMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/gamification': {
      id: '/w/$workspaceId/settings/gamification'
      path: '/w/$workspaceId/settings/gamification'
      fullPath: '/w/$workspaceId/settings/gamification'
      preLoaderRoute: typeof WWorkspaceIdSettingsGamificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/settings/certifications': {
      id: '/w/$workspaceId/settings/certifications'
      path: '/w/$workspaceId/settings/certifications'
      fullPath: '/w/$workspaceId/settings/certifications'
      preLoaderRoute: typeof WWorkspaceIdSettingsCertificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/processes/external-search-details': {
      id: '/w/$workspaceId/processes/external-search-details'
      path: '/w/$workspaceId/processes/external-search-details'
      fullPath: '/w/$workspaceId/processes/external-search-details'
      preLoaderRoute: typeof WWorkspaceIdProcessesExternalSearchDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/processes/external-search': {
      id: '/w/$workspaceId/processes/external-search'
      path: '/w/$workspaceId/processes/external-search'
      fullPath: '/w/$workspaceId/processes/external-search'
      preLoaderRoute: typeof WWorkspaceIdProcessesExternalSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/financeiro/resumo': {
      id: '/w/$workspaceId/financeiro/resumo'
      path: '/resumo'
      fullPath: '/w/$workspaceId/financeiro/resumo'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroResumoRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/previsao-sucumbencia': {
      id: '/w/$workspaceId/financeiro/previsao-sucumbencia'
      path: '/previsao-sucumbencia'
      fullPath: '/w/$workspaceId/financeiro/previsao-sucumbencia'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroPrevisaoSucumbenciaRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/pendencias': {
      id: '/w/$workspaceId/financeiro/pendencias'
      path: '/pendencias'
      fullPath: '/w/$workspaceId/financeiro/pendencias'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroPendenciasRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/lancamentos': {
      id: '/w/$workspaceId/financeiro/lancamentos'
      path: '/lancamentos'
      fullPath: '/w/$workspaceId/financeiro/lancamentos'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroLancamentosRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/importacao': {
      id: '/w/$workspaceId/financeiro/importacao'
      path: '/importacao'
      fullPath: '/w/$workspaceId/financeiro/importacao'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroImportacaoRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/fluxo': {
      id: '/w/$workspaceId/financeiro/fluxo'
      path: '/fluxo'
      fullPath: '/w/$workspaceId/financeiro/fluxo'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroFluxoRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/contas-receber': {
      id: '/w/$workspaceId/financeiro/contas-receber'
      path: '/contas-receber'
      fullPath: '/w/$workspaceId/financeiro/contas-receber'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroContasReceberRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/contas-pagar': {
      id: '/w/$workspaceId/financeiro/contas-pagar'
      path: '/contas-pagar'
      fullPath: '/w/$workspaceId/financeiro/contas-pagar'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroContasPagarRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/financeiro/configuracoes': {
      id: '/w/$workspaceId/financeiro/configuracoes'
      path: '/configuracoes'
      fullPath: '/w/$workspaceId/financeiro/configuracoes'
      preLoaderRoute: typeof WWorkspaceIdFinanceiroConfiguracoesRouteImport
      parentRoute: typeof WWorkspaceIdFinanceiroRoute
    }
    '/w/$workspaceId/clients/new': {
      id: '/w/$workspaceId/clients/new'
      path: '/new'
      fullPath: '/w/$workspaceId/clients/new'
      preLoaderRoute: typeof WWorkspaceIdClientsNewRouteImport
      parentRoute: typeof WWorkspaceIdClientsRoute
    }
    '/w/$workspaceId/clients/$clientId': {
      id: '/w/$workspaceId/clients/$clientId'
      path: '/$clientId'
      fullPath: '/w/$workspaceId/clients/$clientId'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdRouteImport
      parentRoute: typeof WWorkspaceIdClientsRoute
    }
    '/client/processes/$processId/tasks': {
      id: '/client/processes/$processId/tasks'
      path: '/tasks'
      fullPath: '/client/processes/$processId/tasks'
      preLoaderRoute: typeof ClientProcessesProcessIdTasksRouteImport
      parentRoute: typeof ClientProcessesProcessIdRoute
    }
    '/client/processes/$processId/sync-history': {
      id: '/client/processes/$processId/sync-history'
      path: '/sync-history'
      fullPath: '/client/processes/$processId/sync-history'
      preLoaderRoute: typeof ClientProcessesProcessIdSyncHistoryRouteImport
      parentRoute: typeof ClientProcessesProcessIdRoute
    }
    '/certificacao/cursos/$courseId/simulado': {
      id: '/certificacao/cursos/$courseId/simulado'
      path: '/simulado'
      fullPath: '/certificacao/cursos/$courseId/simulado'
      preLoaderRoute: typeof CertificacaoCursosCourseIdSimuladoRouteImport
      parentRoute: typeof CertificacaoCursosCourseIdRoute
    }
    '/admin/tribunais/$tribunalId/calibracao': {
      id: '/admin/tribunais/$tribunalId/calibracao'
      path: '/tribunais/$tribunalId/calibracao'
      fullPath: '/admin/tribunais/$tribunalId/calibracao'
      preLoaderRoute: typeof AdminTribunaisTribunalIdCalibracaoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/w/$workspaceId/clients/$clientId/processes': {
      id: '/w/$workspaceId/clients/$clientId/processes'
      path: '/processes'
      fullPath: '/w/$workspaceId/clients/$clientId/processes'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdProcessesRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdRoute
    }
    '/w/$workspaceId/clients/$clientId/documents': {
      id: '/w/$workspaceId/clients/$clientId/documents'
      path: '/documents'
      fullPath: '/w/$workspaceId/clients/$clientId/documents'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdDocumentsRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdRoute
    }
    '/certificacao/cursos/$courseId/etapa/$stepId': {
      id: '/certificacao/cursos/$courseId/etapa/$stepId'
      path: '/etapa/$stepId'
      fullPath: '/certificacao/cursos/$courseId/etapa/$stepId'
      preLoaderRoute: typeof CertificacaoCursosCourseIdEtapaStepIdRouteImport
      parentRoute: typeof CertificacaoCursosCourseIdRoute
    }
    '/w/$workspaceId/clients/$clientId/processes/$processId': {
      id: '/w/$workspaceId/clients/$clientId/processes/$processId'
      path: '/$processId'
      fullPath: '/w/$workspaceId/clients/$clientId/processes/$processId'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdProcessesRoute
    }
    '/w/$workspaceId/clients/$clientId/processes/$processId/': {
      id: '/w/$workspaceId/clients/$clientId/processes/$processId/'
      path: '/'
      fullPath: '/w/$workspaceId/clients/$clientId/processes/$processId/'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdRoute
    }
    '/w/$workspaceId/clients/$clientId/processes/$processId/tasks': {
      id: '/w/$workspaceId/clients/$clientId/processes/$processId/tasks'
      path: '/tasks'
      fullPath: '/w/$workspaceId/clients/$clientId/processes/$processId/tasks'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdTasksRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdRoute
    }
    '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history': {
      id: '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history'
      path: '/sync-history'
      fullPath: '/w/$workspaceId/clients/$clientId/processes/$processId/sync-history'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdRoute
    }
    '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro': {
      id: '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro'
      path: '/financeiro'
      fullPath: '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro'
      preLoaderRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRouteImport
      parentRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminWorkspaceWorkspaceIdRoute: typeof AdminWorkspaceWorkspaceIdRoute
  AdminTribunaisTribunalIdCalibracaoRoute: typeof AdminTribunaisTribunalIdCalibracaoRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminWorkspaceWorkspaceIdRoute: AdminWorkspaceWorkspaceIdRoute,
  AdminTribunaisTribunalIdCalibracaoRoute:
    AdminTribunaisTribunalIdCalibracaoRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CertificacaoCursosCourseIdRouteChildren {
  CertificacaoCursosCourseIdSimuladoRoute: typeof CertificacaoCursosCourseIdSimuladoRoute
  CertificacaoCursosCourseIdIndexRoute: typeof CertificacaoCursosCourseIdIndexRoute
  CertificacaoCursosCourseIdEtapaStepIdRoute: typeof CertificacaoCursosCourseIdEtapaStepIdRoute
}

const CertificacaoCursosCourseIdRouteChildren: CertificacaoCursosCourseIdRouteChildren =
  {
    CertificacaoCursosCourseIdSimuladoRoute:
      CertificacaoCursosCourseIdSimuladoRoute,
    CertificacaoCursosCourseIdIndexRoute: CertificacaoCursosCourseIdIndexRoute,
    CertificacaoCursosCourseIdEtapaStepIdRoute:
      CertificacaoCursosCourseIdEtapaStepIdRoute,
  }

const CertificacaoCursosCourseIdRouteWithChildren =
  CertificacaoCursosCourseIdRoute._addFileChildren(
    CertificacaoCursosCourseIdRouteChildren,
  )

interface CertificacaoRouteChildren {
  CertificacaoIndexRoute: typeof CertificacaoIndexRoute
  CertificacaoCertificadosIdRoute: typeof CertificacaoCertificadosIdRoute
  CertificacaoCursosCourseIdRoute: typeof CertificacaoCursosCourseIdRouteWithChildren
}

const CertificacaoRouteChildren: CertificacaoRouteChildren = {
  CertificacaoIndexRoute: CertificacaoIndexRoute,
  CertificacaoCertificadosIdRoute: CertificacaoCertificadosIdRoute,
  CertificacaoCursosCourseIdRoute: CertificacaoCursosCourseIdRouteWithChildren,
}

const CertificacaoRouteWithChildren = CertificacaoRoute._addFileChildren(
  CertificacaoRouteChildren,
)

interface ClientProcessesProcessIdRouteChildren {
  ClientProcessesProcessIdSyncHistoryRoute: typeof ClientProcessesProcessIdSyncHistoryRoute
  ClientProcessesProcessIdTasksRoute: typeof ClientProcessesProcessIdTasksRoute
  ClientProcessesProcessIdIndexRoute: typeof ClientProcessesProcessIdIndexRoute
}

const ClientProcessesProcessIdRouteChildren: ClientProcessesProcessIdRouteChildren =
  {
    ClientProcessesProcessIdSyncHistoryRoute:
      ClientProcessesProcessIdSyncHistoryRoute,
    ClientProcessesProcessIdTasksRoute: ClientProcessesProcessIdTasksRoute,
    ClientProcessesProcessIdIndexRoute: ClientProcessesProcessIdIndexRoute,
  }

const ClientProcessesProcessIdRouteWithChildren =
  ClientProcessesProcessIdRoute._addFileChildren(
    ClientProcessesProcessIdRouteChildren,
  )

interface ClientRouteChildren {
  ClientInvitesRoute: typeof ClientInvitesRoute
  ClientIndexRoute: typeof ClientIndexRoute
  ClientProcessesProcessIdRoute: typeof ClientProcessesProcessIdRouteWithChildren
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientInvitesRoute: ClientInvitesRoute,
  ClientIndexRoute: ClientIndexRoute,
  ClientProcessesProcessIdRoute: ClientProcessesProcessIdRouteWithChildren,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

interface CommunityJobsRouteChildren {
  CommunityJobsJobIdRoute: typeof CommunityJobsJobIdRoute
  CommunityJobsNewRoute: typeof CommunityJobsNewRoute
  CommunityJobsIndexRoute: typeof CommunityJobsIndexRoute
}

const CommunityJobsRouteChildren: CommunityJobsRouteChildren = {
  CommunityJobsJobIdRoute: CommunityJobsJobIdRoute,
  CommunityJobsNewRoute: CommunityJobsNewRoute,
  CommunityJobsIndexRoute: CommunityJobsIndexRoute,
}

const CommunityJobsRouteWithChildren = CommunityJobsRoute._addFileChildren(
  CommunityJobsRouteChildren,
)

interface CommunityRouteChildren {
  CommunityConnectionsRoute: typeof CommunityConnectionsRoute
  CommunityFeedRoute: typeof CommunityFeedRoute
  CommunityJobsRoute: typeof CommunityJobsRouteWithChildren
  CommunitySearchRoute: typeof CommunitySearchRoute
  CommunityIndexRoute: typeof CommunityIndexRoute
  CommunityArticlesArticleIdRoute: typeof CommunityArticlesArticleIdRoute
  CommunityArticlesNewRoute: typeof CommunityArticlesNewRoute
  CommunityProfileUserIdRoute: typeof CommunityProfileUserIdRoute
  CommunityProfileEditRoute: typeof CommunityProfileEditRoute
}

const CommunityRouteChildren: CommunityRouteChildren = {
  CommunityConnectionsRoute: CommunityConnectionsRoute,
  CommunityFeedRoute: CommunityFeedRoute,
  CommunityJobsRoute: CommunityJobsRouteWithChildren,
  CommunitySearchRoute: CommunitySearchRoute,
  CommunityIndexRoute: CommunityIndexRoute,
  CommunityArticlesArticleIdRoute: CommunityArticlesArticleIdRoute,
  CommunityArticlesNewRoute: CommunityArticlesNewRoute,
  CommunityProfileUserIdRoute: CommunityProfileUserIdRoute,
  CommunityProfileEditRoute: CommunityProfileEditRoute,
}

const CommunityRouteWithChildren = CommunityRoute._addFileChildren(
  CommunityRouteChildren,
)

interface WWorkspaceIdClientsClientIdProcessesProcessIdRouteChildren {
  WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute
  WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute
  WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute
  WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute
}

const WWorkspaceIdClientsClientIdProcessesProcessIdRouteChildren: WWorkspaceIdClientsClientIdProcessesProcessIdRouteChildren =
  {
    WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute:
      WWorkspaceIdClientsClientIdProcessesProcessIdFinanceiroRoute,
    WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute:
      WWorkspaceIdClientsClientIdProcessesProcessIdSyncHistoryRoute,
    WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute:
      WWorkspaceIdClientsClientIdProcessesProcessIdTasksRoute,
    WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute:
      WWorkspaceIdClientsClientIdProcessesProcessIdIndexRoute,
  }

const WWorkspaceIdClientsClientIdProcessesProcessIdRouteWithChildren =
  WWorkspaceIdClientsClientIdProcessesProcessIdRoute._addFileChildren(
    WWorkspaceIdClientsClientIdProcessesProcessIdRouteChildren,
  )

interface WWorkspaceIdClientsClientIdProcessesRouteChildren {
  WWorkspaceIdClientsClientIdProcessesProcessIdRoute: typeof WWorkspaceIdClientsClientIdProcessesProcessIdRouteWithChildren
}

const WWorkspaceIdClientsClientIdProcessesRouteChildren: WWorkspaceIdClientsClientIdProcessesRouteChildren =
  {
    WWorkspaceIdClientsClientIdProcessesProcessIdRoute:
      WWorkspaceIdClientsClientIdProcessesProcessIdRouteWithChildren,
  }

const WWorkspaceIdClientsClientIdProcessesRouteWithChildren =
  WWorkspaceIdClientsClientIdProcessesRoute._addFileChildren(
    WWorkspaceIdClientsClientIdProcessesRouteChildren,
  )

interface WWorkspaceIdClientsClientIdRouteChildren {
  WWorkspaceIdClientsClientIdDocumentsRoute: typeof WWorkspaceIdClientsClientIdDocumentsRoute
  WWorkspaceIdClientsClientIdProcessesRoute: typeof WWorkspaceIdClientsClientIdProcessesRouteWithChildren
}

const WWorkspaceIdClientsClientIdRouteChildren: WWorkspaceIdClientsClientIdRouteChildren =
  {
    WWorkspaceIdClientsClientIdDocumentsRoute:
      WWorkspaceIdClientsClientIdDocumentsRoute,
    WWorkspaceIdClientsClientIdProcessesRoute:
      WWorkspaceIdClientsClientIdProcessesRouteWithChildren,
  }

const WWorkspaceIdClientsClientIdRouteWithChildren =
  WWorkspaceIdClientsClientIdRoute._addFileChildren(
    WWorkspaceIdClientsClientIdRouteChildren,
  )

interface WWorkspaceIdClientsRouteChildren {
  WWorkspaceIdClientsClientIdRoute: typeof WWorkspaceIdClientsClientIdRouteWithChildren
  WWorkspaceIdClientsNewRoute: typeof WWorkspaceIdClientsNewRoute
}

const WWorkspaceIdClientsRouteChildren: WWorkspaceIdClientsRouteChildren = {
  WWorkspaceIdClientsClientIdRoute:
    WWorkspaceIdClientsClientIdRouteWithChildren,
  WWorkspaceIdClientsNewRoute: WWorkspaceIdClientsNewRoute,
}

const WWorkspaceIdClientsRouteWithChildren =
  WWorkspaceIdClientsRoute._addFileChildren(WWorkspaceIdClientsRouteChildren)

interface WWorkspaceIdFinanceiroRouteChildren {
  WWorkspaceIdFinanceiroConfiguracoesRoute: typeof WWorkspaceIdFinanceiroConfiguracoesRoute
  WWorkspaceIdFinanceiroContasPagarRoute: typeof WWorkspaceIdFinanceiroContasPagarRoute
  WWorkspaceIdFinanceiroContasReceberRoute: typeof WWorkspaceIdFinanceiroContasReceberRoute
  WWorkspaceIdFinanceiroFluxoRoute: typeof WWorkspaceIdFinanceiroFluxoRoute
  WWorkspaceIdFinanceiroImportacaoRoute: typeof WWorkspaceIdFinanceiroImportacaoRoute
  WWorkspaceIdFinanceiroLancamentosRoute: typeof WWorkspaceIdFinanceiroLancamentosRoute
  WWorkspaceIdFinanceiroPendenciasRoute: typeof WWorkspaceIdFinanceiroPendenciasRoute
  WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute: typeof WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute
  WWorkspaceIdFinanceiroResumoRoute: typeof WWorkspaceIdFinanceiroResumoRoute
  WWorkspaceIdFinanceiroIndexRoute: typeof WWorkspaceIdFinanceiroIndexRoute
}

const WWorkspaceIdFinanceiroRouteChildren: WWorkspaceIdFinanceiroRouteChildren =
  {
    WWorkspaceIdFinanceiroConfiguracoesRoute:
      WWorkspaceIdFinanceiroConfiguracoesRoute,
    WWorkspaceIdFinanceiroContasPagarRoute:
      WWorkspaceIdFinanceiroContasPagarRoute,
    WWorkspaceIdFinanceiroContasReceberRoute:
      WWorkspaceIdFinanceiroContasReceberRoute,
    WWorkspaceIdFinanceiroFluxoRoute: WWorkspaceIdFinanceiroFluxoRoute,
    WWorkspaceIdFinanceiroImportacaoRoute:
      WWorkspaceIdFinanceiroImportacaoRoute,
    WWorkspaceIdFinanceiroLancamentosRoute:
      WWorkspaceIdFinanceiroLancamentosRoute,
    WWorkspaceIdFinanceiroPendenciasRoute:
      WWorkspaceIdFinanceiroPendenciasRoute,
    WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute:
      WWorkspaceIdFinanceiroPrevisaoSucumbenciaRoute,
    WWorkspaceIdFinanceiroResumoRoute: WWorkspaceIdFinanceiroResumoRoute,
    WWorkspaceIdFinanceiroIndexRoute: WWorkspaceIdFinanceiroIndexRoute,
  }

const WWorkspaceIdFinanceiroRouteWithChildren =
  WWorkspaceIdFinanceiroRoute._addFileChildren(
    WWorkspaceIdFinanceiroRouteChildren,
  )

interface WWorkspaceIdWorkflowPresetsRouteChildren {
  WWorkspaceIdWorkflowPresetsPresetIdRoute: typeof WWorkspaceIdWorkflowPresetsPresetIdRoute
  WWorkspaceIdWorkflowPresetsIndexRoute: typeof WWorkspaceIdWorkflowPresetsIndexRoute
}

const WWorkspaceIdWorkflowPresetsRouteChildren: WWorkspaceIdWorkflowPresetsRouteChildren =
  {
    WWorkspaceIdWorkflowPresetsPresetIdRoute:
      WWorkspaceIdWorkflowPresetsPresetIdRoute,
    WWorkspaceIdWorkflowPresetsIndexRoute:
      WWorkspaceIdWorkflowPresetsIndexRoute,
  }

const WWorkspaceIdWorkflowPresetsRouteWithChildren =
  WWorkspaceIdWorkflowPresetsRoute._addFileChildren(
    WWorkspaceIdWorkflowPresetsRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AssinaturasRoute: AssinaturasRoute,
  CertificacaoRoute: CertificacaoRouteWithChildren,
  ClientRoute: ClientRouteWithChildren,
  CommunityRoute: CommunityRouteWithChildren,
  InvitesRoute: InvitesRoute,
  LoginRoute: LoginRoute,
  PoliticaCancelamentoReembolsoRoute: PoliticaCancelamentoReembolsoRoute,
  PoliticaPrivacidadeCookiesRoute: PoliticaPrivacidadeCookiesRoute,
  PrometeusRoute: PrometeusRoute,
  SettingsRoute: SettingsRoute,
  TermosRoute: TermosRoute,
  WorkspacesRoute: WorkspacesRoute,
  CheckoutCancelRoute: CheckoutCancelRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  RegisterClientInviteTokenRoute: RegisterClientInviteTokenRoute,
  RegisterInviteTokenRoute: RegisterInviteTokenRoute,
  WWorkspaceIdAgendaRoute: WWorkspaceIdAgendaRoute,
  WWorkspaceIdCertificacoesRoute: WWorkspaceIdCertificacoesRoute,
  WWorkspaceIdChatRoute: WWorkspaceIdChatRoute,
  WWorkspaceIdClientInvitesRoute: WWorkspaceIdClientInvitesRoute,
  WWorkspaceIdClientsRoute: WWorkspaceIdClientsRouteWithChildren,
  WWorkspaceIdDocumentsRoute: WWorkspaceIdDocumentsRoute,
  WWorkspaceIdFinanceiroRoute: WWorkspaceIdFinanceiroRouteWithChildren,
  WWorkspaceIdGamificationRoute: WWorkspaceIdGamificationRoute,
  WWorkspaceIdMetricsRoute: WWorkspaceIdMetricsRoute,
  WWorkspaceIdNotificationsRoute: WWorkspaceIdNotificationsRoute,
  WWorkspaceIdPlanRoute: WWorkspaceIdPlanRoute,
  WWorkspaceIdPublicationsRoute: WWorkspaceIdPublicationsRoute,
  WWorkspaceIdShopRoute: WWorkspaceIdShopRoute,
  WWorkspaceIdTasksRoute: WWorkspaceIdTasksRoute,
  WWorkspaceIdWorkflowPresetsRoute:
    WWorkspaceIdWorkflowPresetsRouteWithChildren,
  WWorkspaceIdProcessesExternalSearchRoute:
    WWorkspaceIdProcessesExternalSearchRoute,
  WWorkspaceIdProcessesExternalSearchDetailsRoute:
    WWorkspaceIdProcessesExternalSearchDetailsRoute,
  WWorkspaceIdSettingsCertificationsRoute:
    WWorkspaceIdSettingsCertificationsRoute,
  WWorkspaceIdSettingsGamificationRoute: WWorkspaceIdSettingsGamificationRoute,
  WWorkspaceIdSettingsMembersRoute: WWorkspaceIdSettingsMembersRoute,
  WWorkspaceIdSettingsRolesRoute: WWorkspaceIdSettingsRolesRoute,
  WWorkspaceIdSettingsTagsRoute: WWorkspaceIdSettingsTagsRoute,
  WWorkspaceIdSettingsTermosRoute: WWorkspaceIdSettingsTermosRoute,
  WWorkspaceIdSettingsWorkGroupsRoute: WWorkspaceIdSettingsWorkGroupsRoute,
  WWorkspaceIdSettingsWorkflowPresetsRoute:
    WWorkspaceIdSettingsWorkflowPresetsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
